import { useQuery } from '@tanstack/react-query';
import { getLojasParticipantes } from '../Cadastro/LojasParticipantes/services';

export const useGetLojasParticipantes = (id: string | number, params?: any) => {
  return useQuery({
    queryKey: ['lojasParticipantes', id, params],
    queryFn: () => getLojasParticipantes({ ...params, id }),
    enabled: !!id,
  });
};
